import { VNodeDirective } from 'vue';

export default {
  inserted(el: HTMLElement, binding: VNodeDirective) {
    el.setAttribute('data-e2e', `${binding.value}`);
  },
};
